import Live2MCPage from "../views/live2/mc";
import LiveV2MTPage from "../views/live2/mt";
import LiveV2TNPage from "../views/live2/tn";
import LiveV2TNBlackPage from "../views/live2/tn-black";
import Live2LeapPage from "../views/live2/leap";
import Live2SCPage from "../views/live2/sc";
import Live2KHPage from "../views/live2/kh";
import Live2KPPage from "../views/live2/kp";
import Live2TN830Page from "../views/live2/tn-minhngoc";
import Live2MCBlackPage from "../views/live2/mc-black";
import Live2TNBlack830Page from "../views/live2/tn-minhngoc-black";

import Live3TNPage from "../views/live3/tn";
import Live3TN830Page from "../views/live3/tn-minhngoc";
import Live3MTPage from "../views/live3/mt";
import Live3MCPage from "../views/live3/mc";
import Live3LeapPage from "../views/live3/leap";
import Live3SCPage from "../views/live3/sc";
import Live3KHPage from "../views/live3/kh";

import LiveRouteWrapper from "../components/LiveRouteWrapper";

// Base V2 configuration
const v2Pages = [
    {slug: "mt", name: "MT", Component: LiveV2MTPage},
    {slug: "tc", name: "TC", Component: LiveV2TNPage},
    {slug: "tc_minhngoc", name: "TC-Minhngoc", Component: Live2TN830Page},
    {slug: "mc", name: "MC", Component: Live2MCPage},
    {slug: "leap", name: "LEAP", Component: Live2LeapPage},
    {slug: "sc", name: "SC", Component: Live2SCPage},
    {slug: "kh", name: "KH", Component: Live2KHPage},
    {slug: "kp", name: "KP", Component: Live2KPPage},
];

// Black variant
const blackPages = [
    {slug: "mc-black", name: "MC Black", Component: Live2MCBlackPage},
    {slug: "tc-black", name: "TC Black", Component: LiveV2TNBlackPage},
    {slug: "tc_minhngoc-black", name: "TC-Minhngoc Black", Component: Live2TNBlack830Page},
];

// Base V3 configuration
const v3Pages = [
    {slug: "mt", name: "MT", Component: Live3MTPage},
    {slug: "mc", name: "MC", Component: Live3MCPage},
    {slug: "tc", name: "TC", Component: Live3TNPage},
    {slug: "tc_minhngoc", name: "TC-Minhngoc", Component: Live3TN830Page},
    {slug: "leap", name: "LEAP", Component: Live3LeapPage},
    {slug: "sc", name: "SC", Component: Live3SCPage},
    {slug: "kh", name: "KH", Component: Live3KHPage},

    // Intentionally reuses V2 KP page
    {slug: "kp", name: "KP", Component: Live2KPPage},
];

function createRoutes(pages, prefix, withAudio = false) {
    return pages.map(({slug, name, Component}) => ({
        path: `/${prefix}/${slug}`,
        name,
        element: withAudio ? (
            <LiveRouteWrapper type={slug}>
                <Component/>
            </LiveRouteWrapper>
        ) : (
            <Component/>
        ),
    }));
}

export const routes = createRoutes(v2Pages, "live-v2");

export const routesBlack = createRoutes(
    blackPages,
    "live-v2"
);

export const routesV3 = createRoutes(v3Pages, "live-v3");

export const routesFull = createRoutes(
    v2Pages,
    "live-full",
    true
);

export const routesV4 = createRoutes(
    v3Pages,
    "live-v4",
    true
);

export const allLiveRoutes = [
    ...routes,
    ...routesBlack,
    ...routesV3,
    ...routesFull,
    ...routesV4,
];
